import Events from "@wwdev/bootstrap/Events";
import Tooltips from "./tooltips";
new Tooltips();

Events.on('wwdev.checkout.update.finish', () => {
	new Tooltips({
		scope: '#webshop_form [data-bs-toggle="tooltip"]'
	});
});